import type * as menuButtonModule from "./PaneSwitcher";
import type { PaneSwitcherProps } from "./PaneSwitcher.Props";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";

const lazyModule: LazyModule<typeof menuButtonModule> = new LazyModule(() => import(/* webpackChunkName: "CopilotChatPaneSwitcher" */ "./PaneSwitcher"), { name: "PaneSwitcher" });

export const LazyPaneSwitcher: LazyComponent<PaneSwitcherProps, undefined> = createLazyComponent(lazyModule, module => module.PaneSwitcher);
